/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type TelcoBillJobState = 0 | 1 | 2 | 3 | 4 | 5;

export const TelcoBillJobState = {
    NUMBER_0: 0 as TelcoBillJobState,
    NUMBER_1: 1 as TelcoBillJobState,
    NUMBER_2: 2 as TelcoBillJobState,
    NUMBER_3: 3 as TelcoBillJobState,
    NUMBER_4: 4 as TelcoBillJobState,
    NUMBER_5: 5 as TelcoBillJobState
};
